<template>
  <section>
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card style="background-color: #f4f5fa;">
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Diary Record</v-toolbar-title>
          <v-spacer></v-spacer>
        <!-- <v-toolbar-items>
          <v-btn
            dark
            text
            @click="handleDiary"
          >
            Save
          </v-btn>
        </v-toolbar-items> -->
        </v-toolbar>
        <div>
          <center class="pt-2">
            <v-icon @click="prev">
              mdi-chevron-double-left
            </v-icon>

            <span class=" pl-5 pr-5"><span class="summary-day">(Day {{ record.courseDay }})</span> {{ formatDate(record.courseDate) }}
            </span>
            <v-icon @click="next">
              mdi-chevron-double-right
            </v-icon>
          </center>
          <section class="pl-2 pr-2 pt-2 ">
            <v-card
              rounded-lg
              class="mb-3"
            >
              <v-icon
                class="abs-icon "
                @click="handleChartNav('workType')"
              >
                mdi-chevron-double-right
              </v-icon>
              <div class="pl-2 pr-2 pt-2 pb-2 label-black">
                <span class="text-bold font-italic">
                  <span>Body Parts Exercised</span>
                </span>
                <v-row no-gutters>
                  <v-col cols="4">
                    <div class="label-blue content-text">
                      Workout Type
                    </div>
                    <div class="content-text">
                      {{ getWorkoutTypeDesc(record.workoutTypeID) }}
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="label-red content-text">
                      Workout Intensity
                    </div>
                    <div class="content-text">
                      {{ record.workoutIntensity }}%
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
            <v-card
              rounded-lg
              class="mb-3"
            >
              <v-icon
                class="abs-icon "
                @click="handleChartNav('dailyEvaluation')"
              >
                mdi-chevron-double-right
              </v-icon>
              <div class="pl-2 pr-2 pt-2 pb-2 label-black">
                <div class="text-bold font-italic">
                  <div>Daily Evaluation</div>
                  <div>{{ record.dailyEvaluation }}</div>
                </div>
                <v-row no-gutters>
                  <v-col cols="3">
                    <div class="label-blue content-text">
                      Sleep
                    </div>
                    <div class="content-text">
                      {{ record.hourSelptLastNight }} hrs
                    </div>
                  </v-col>
                  <v-col cols="3">
                    <div class="label-green content-text">
                      Appetite
                    </div>
                    <div class="content-text">
                      {{ getCourseCommentDesc(record.appetiteID) }}
                    </div>
                  </v-col>
                  <v-col cols="3">
                    <div class="label-red content-text">
                      Mood
                    </div>
                    <div class="content-text">
                      {{ getCourseCommentDesc(record.moodID) }}
                    </div>
                  </v-col>
                  <v-col cols="3">
                    <div class="label-orange content-text">
                      Energy
                    </div>
                    <div class="content-text">
                      {{ getCourseCommentDesc(record.energyID) }}
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
            <v-card
              rounded-lg
              class="mb-3"
            >
              <v-icon
                class="abs-icon "
                @click="handleChartNav('bodyWeight')"
              >
                mdi-chevron-double-right
              </v-icon>
              <div class="pl-2 pr-2 pt-2 pb-2">
                <div class="text-bold font-italic label-black">
                  <div>Weight</div>
                </div>
                <div>
                  <span class="label-black text-black ">{{ record.bodyWeight }} </span><span class="content-text">KG</span>
                </div>
              </div>
            </v-card>
            <v-card
              rounded-lg
              class="mb-3"
            >
              <v-icon
                class="abs-icon "
                @click="handleChartNav('caloriesExpended')"
              >
                mdi-chevron-double-right
              </v-icon>
              <div class="pl-2 pr-2 pt-2 pb-2">
                <div class="text-bold font-italic label-black">
                  <div>Calories Expended</div>
                </div>
                <div>
                  <span class="label-black text-black ">{{ record.caloriesExpended }} </span><span class="content-text">Cals</span>
                </div>
              </div>
            </v-card>
            <v-card
              rounded
              class="mb-3"
            >
              <v-icon
                class="abs-icon "
                @click="handleChartNav('trainingItem')"
              >
                mdi-chevron-double-right
              </v-icon>
              <div class="pl-2 pr-2 pt-2 pb-2 content-text label-black">
                <v-row
                  v-for="trainingItem in record.trainingItems"
                  :key="trainingItem.id"
                  no-gutters
                >
                  <v-col
                    md="3"
                    lg="3"
                    cols="5"
                    class="label-blue"
                  >
                    {{ getCourseItemDesc(trainingItem.courseItemID) }}
                  </v-col>
                  <v-col
                    cols="7"
                  >
                    <div class="comment-overflow-hidden">
                      {{ trainingItem.remark }}
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
            <v-card
              v-if="record.trainingAerobicItems.length"
              rounded
              class="mb-3"
            >
              <div class="pl-2 pr-2 pt-2 pb-2 content-text label-black">
                <v-row
                  v-for="item in record.trainingAerobicItems"
                  :key="item.id"
                  no-gutters
                >
                  <v-col
                    md="3"
                    lg="3"
                    cols="5"
                    class="label-blue"
                  >
                    {{ getAerobicItemDesc(item.aerobicItemID) }}
                  </v-col>
                  <v-col>
                    <div
                      cols="7"
                      class="comment-overflow-hidden"
                    >
                      {{ item.duration }} {{ item.unit }}
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </section>
        </div>
      </v-card>
    </v-dialog>
    <DiaryChart
      ref="diaryChart"
      v-model="diaryChartDialog"
      :record="record"
    >
    </DiaryChart>
  </section>
</template>
<script setup>
import { ref, onMounted, computed, watch, toRefs, nextTick } from 'vue'
import { getVuetify } from '@core/utils'
import { formatTime, formatDate, loading } from '@/utils/helper'
import DiaryChart from './DiaryChart.vue'

import { fetchCourseComment, fetchWorkoutType } from '@/api/courseComment'

import {
  listCourseItem,
  listAerobicItem,
} from '@/api/diaryRecord'

const diaryChart = ref(null)

const diaryChartDialog = ref(false)

const $vuetify = getVuetify()

function handleChartNav(target) {
  console.log('diaryChart.value', diaryChart.value)
  console.log('target', target)
  console.log('$vuetify', $vuetify)
  diaryChart.value.tab = 0
  diaryChartDialog.value = true

  diaryChart.value.goTo(target)

  // nextTick(() => {
  //   if (target === 'bodyWeight') {
  //     $vuetify.goTo(diaryChart.value.weeklyBodyWeightRef)
  //   } else if (target === 'dailyEvaluation') {
  //     $vuetify.goTo(diaryChart.value.weeklySleepRef)
  //   } else if (target === 'caloriesExpended') {
  //     $vuetify.goTo(diaryChart.value.weeklyCaloriesExpendedRef)
  //   } else if (target === 'trainingItem') {
  //     diaryChart.value.tab = 2
  //     $vuetify.goTo(diaryChart.value.trainingItemsRef)
  //   }
  // })
}

const courseCommentSelection = [...fetchCourseComment()]

function getCourseCommentDesc(id) {
  if (id > 0) {
    return courseCommentSelection.find(item => item.id === id).description
  }

  return ''
}

const courseItems = ref([])
listCourseItem({}).then(res => {
  courseItems.value = [...res.data.items]
})

const aerobicItems = ref([])
listAerobicItem({}).then(res => {
  aerobicItems.value = [...res.data.items]
})

function getAerobicItemDesc(id) {
  const aerobicItem = aerobicItems.value.find(item => item.id === id)
  if (aerobicItem) {
    return aerobicItem.description
  }

  return ''
}
function getCourseItemDesc(id) {
  const courseItem = courseItems.value.find(item => item.id === id)
  if (courseItem) {
    return courseItem.description
  }

  return ''
}

const workoutTypeSelection = [...fetchWorkoutType()]

function getWorkoutTypeDesc(id) {
  if (id > 0) {
    return workoutTypeSelection.find(item => item.id === id).description
  }

  return ''
}

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  record: {
    type: Object,
    default() {
      return {
        userRecordID: 0,
        courseDate: '0001-01-01T00:00:00.000Z',
        courseDay: 0,
        workoutTypeID: 0,
        workoutIntensity: 0,
        dailyEvaluation: '',
        hourSelptLastNight: 0,
        moodID: 2,
        appetiteID: 0,
        energyID: 0,
        bodyWeight: 0,
        caloriesExpended: 0,
        trainingItems: [
        ],
        trainingAerobicItems: [],
        id: 0,
      }
    },
  },
})
const { value, record } = toRefs(props)

const dialog = ref(value.value)

const emits = defineEmits(['input', 'closed', 'prev', 'next'])
watch(dialog, val => {
  console.log('diaryDialog', val)
  emits('input', val)
})

function prev() {
  emits('prev', record.value.courseDate)
}

function next() {
  emits('next', record.value.courseDate)
}

watch(value, val => {
  console.log('value', val)
  dialog.value = val
})

onMounted(() => {
  dialog.value = value.value
})
</script>
<style scoped>
.summary-day{
  color:blue;
}
.content-text{
  font-size: 9px;
}
.label-blue{
  color:#2D78F0;
}
.label-green{
  color:#96D45A
}
.label-red{
  color:#DA0063;
}

.label-orange{
  color:#F24726;
}
.label-black{
  color:black;
}
.comment-overflow-hidden{
  overflow-x: hidden;
  white-space: nowrap;
}
.abs-icon{
  position: absolute;
  right: 0;
  top: 0;
  /* color: #2D78F0; */
  font-size: 25px;
  background-color:white;
  cursor: pointer;
}
</style>
